<form [formGroup]="form">
  <app-fiscal-preview [fiscal]="fiscal"></app-fiscal-preview>
  <app-accept-terms formControlName="acceptedTerms" [terms]="terms"></app-accept-terms>
  <xena-alert type="danger" open *ngIf="showError && form.get('acceptedTerms').hasError('notAllTermsAccepted')">
    <xena-icon slot="icon" name="fas-exclamation-circle"></xena-icon>
    <span i18n="@@createFiscal_place_accept_all">Please accept all terms before going forward!</span>
  </xena-alert>
</form>
